var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable no-console */
import React, { cloneElement, forwardRef, useContext, useState, useEffect, useMemo, useRef, } from 'react';
import { Grid, ConfigProvider as ArcoConfigProvider } from '@arco-design/web-react';
import ConfigProvider, { useConfigContext } from '@m4b-design/config-provider';
import { cs, isArray, isFunction, isUndefined, isObject, omit, formatValidateMsg, isString, getItemSpacingSize, } from '../utils';
import { VALIDATE_STATUS } from '../constant';
import Control from './control';
import { FormItemContext as RawFormItemContext, FormContext, FormListContext, } from '../context';
import FormItemLabel from './form-label';
import FormItemTip from './form-item-tip';
var ConfigContext = ArcoConfigProvider.ConfigContext;
var Row = Grid.Row;
var Col = Grid.Col;
var Item = function (props, ref) {
    var _a, _b, _c, _d;
    var _e, _f, _g, _h, _j, _k, _l;
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixClsItem = "".concat(globalPrefixCls, "-form-item");
    var label = props.label, subTitle = props.subTitle, helpTip = props.helpTip, helpTipTooltipProps = props.helpTipTooltipProps, prompt = props.prompt, description = props.description, validateMessagesDisplayTypeProps = props.validateMessagesDisplayType, rulesProps = props.rules, extra = props.extra, help = props.help, className = props.className, style = props.style, validateStatus = props.validateStatus, hidden = props.hidden, optional = props.optional, itemSpacingSize = props.itemSpacingSize, rest = __rest(props, ["label", "subTitle", "helpTip", "helpTipTooltipProps", "prompt", "description", "validateMessagesDisplayType", "rules", "extra", "help", "className", "style", "validateStatus", "hidden", "optional", "itemSpacingSize"]);
    var _m = useContext(ConfigContext), getPrefixCls = _m.getPrefixCls, prefix = _m.prefixCls;
    var topFormContext = useContext(RawFormItemContext);
    var formListContext = useContext(FormListContext);
    var _o = __read(useState(null), 2), errors = _o[0], setErrors = _o[1];
    var _p = __read(useState(null), 2), warnings = _p[0], setWarnings = _p[1];
    /**
     * 这里的一些值是在form 有传递过来的，form-item 里也有对应的值，这里需要处理 form 和 form-item的值问题，确定取哪一个，
     */
    // const formLayout = 'vertical';
    var formContext = useContext(FormContext);
    var formLayout = props.layout || formContext.layout;
    var prefixCls = formContext.prefixCls || getPrefixCls('form');
    var labelAlign = props.labelAlign || formContext.labelAlign;
    var isDestroyed = useRef(false);
    var closeColumns = formContext === null || formContext === void 0 ? void 0 : formContext.closeColumns;
    var columnsNum = (_e = formContext === null || formContext === void 0 ? void 0 : formContext.columnsNum) !== null && _e !== void 0 ? _e : 1;
    var optionalVal = optional !== null && optional !== void 0 ? optional : formContext === null || formContext === void 0 ? void 0 : formContext.optional;
    // 获取 form-item 的间距
    var itemSpacingSizeVal = getItemSpacingSize((_f = formContext === null || formContext === void 0 ? void 0 : formContext.itemSpacingSize) !== null && _f !== void 0 ? _f : itemSpacingSize);
    // 处理报错信息的展示类型
    var validateMessagesDisplayType = validateMessagesDisplayTypeProps !== null && validateMessagesDisplayTypeProps !== void 0 ? validateMessagesDisplayTypeProps : formContext === null || formContext === void 0 ? void 0 : formContext.validateMessagesDisplayType;
    var isTooltipDisplayType = validateMessagesDisplayType === 'tooltip';
    // prompt 位置有2处，一处是form-item 底部,一处是 form-item 头部。
    var promptIsBottom = isString(prompt) || isUndefined(prompt) || prompt.position === 'bottom';
    var promptContent = isString(prompt) || isUndefined(prompt) ? prompt : prompt.content;
    // 是否将 rules 和 optional 解绑
    var maintainRawRules = formContext === null || formContext === void 0 ? void 0 : formContext.maintainRawRules;
    /**
     * 对规则做处理，默认 optional 为false, 且默认form-item的required为true
     */
    var rules = rulesProps;
    if (!maintainRawRules) {
        if ((rulesProps === null || rulesProps === void 0 ? void 0 : rulesProps.length) > 0) {
            rules = rulesProps.map(function (item) { return (__assign(__assign({}, item), { required: Boolean(!optionalVal) })); });
        }
        else {
            rules = [{ required: Boolean(!optionalVal) }];
        }
    }
    // 是否为垂直布局
    var isVertical = formLayout === 'vertical';
    // 当前 form-item 是否是独立使用不在 form 容器内。
    var formItemAlone = (_g = formContext === null || formContext === void 0 ? void 0 : formContext.formItemAlone) !== null && _g !== void 0 ? _g : topFormContext === null || topFormContext === void 0 ? void 0 : topFormContext.formItemAlone;
    // update error status
    var updateInnerFormItem = function (field, params) {
        if (params === void 0) { params = {}; }
        if (isDestroyed.current) {
            return;
        }
        var _a = params || {}, errors = _a.errors, warnings = _a.warnings;
        setErrors(function (innerErrors) {
            var newErrors = __assign({}, (innerErrors || {}));
            if (errors) {
                newErrors[field] = errors;
            }
            else {
                delete newErrors[field];
            }
            return newErrors;
        });
        setWarnings(function (current) {
            var newVal = __assign({}, (current || {}));
            if (warnings && warnings.length) {
                newVal[field] = warnings;
            }
            else {
                delete newVal[field];
            }
            return newVal;
        });
    };
    var updateFormItem = isObject(props.noStyle) && props.noStyle.showErrorTip && topFormContext.updateFormItem
        ? topFormContext.updateFormItem
        : updateInnerFormItem;
    useEffect(function () {
        isDestroyed.current = false;
        return function () {
            isDestroyed.current = true;
            setErrors(null);
            setWarnings(null);
        };
    }, []);
    var contextProps = __assign(__assign({}, formContext), { validateMessages: formContext.validateMessages &&
            formatValidateMsg(formContext.validateMessages, {
                label: props.label,
            }), prefixCls: prefixCls, updateFormItem: updateFormItem, disabled: 'disabled' in props ? props.disabled : formContext.disabled });
    var labelClassNames = cs("".concat(prefixCls, "-label-item"), (_a = {},
        _a["".concat(prefixCls, "-label-item-left")] = labelAlign === 'left',
        _a));
    var errorInfo = errors ? Object.values(errors) : [];
    // 当 form-item 单独使用时，需要做定义error 场景，行内报错信息需要透传
    if (formItemAlone && typeof help === 'string') {
        errorInfo = [
            {
                message: help,
            },
        ];
    }
    var warningInfo = warnings
        ? Object.values(warnings).reduce(function (total, next) { return total.concat(next); }, [])
        : [];
    var itemStatus = useMemo(function () {
        if (validateStatus) {
            return validateStatus;
        }
        if (errorInfo.length) {
            return VALIDATE_STATUS.error;
        }
        if (warningInfo.length) {
            return VALIDATE_STATUS.warning;
        }
        return undefined;
    }, [errors, warnings, validateStatus]);
    var hasHelp = useMemo(function () {
        return !isUndefined(props.help) || warningInfo.length > 0;
    }, [props.help, warnings]);
    var classNames = cs("".concat(prefixCls, "-item"), prefixClsItem, (_b = {},
        _b["".concat(prefixCls, "-item-error")] = hasHelp || (!validateStatus && itemStatus === VALIDATE_STATUS.error),
        _b["".concat(prefixCls, "-item-status-").concat(itemStatus)] = itemStatus,
        _b["".concat(prefixCls, "-item-has-help")] = hasHelp,
        _b["".concat(prefixCls, "-item-hidden")] = hidden,
        _b["".concat(prefixCls, "-item-has-feedback")] = itemStatus && props.hasFeedback,
        _b["".concat(prefixCls, "-item-error-tooltip")] = isTooltipDisplayType,
        _b["".concat(prefixCls, "-item-bottom-mini")] = itemSpacingSizeVal === 'mini',
        _b["".concat(prefixCls, "-item-bottom-small")] = itemSpacingSizeVal === 'small',
        _b["".concat(prefixCls, "-item-bottom-default")] = itemSpacingSizeVal === 'default',
        _b), "".concat(prefixCls, "-layout-").concat(formLayout), className);
    var cloneElementWithDisabled = function () {
        var _a, _b;
        var field = props.field, children = props.children;
        var disabled = 'disabled' in props ? props.disabled : formContext.disabled;
        if (isFunction(children)) {
            return (React.createElement(Control, __assign({ disabled: disabled }, props, (field ? { key: field, _key: field } : {}), { rules: rules }), function () {
                var rest = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    rest[_i] = arguments[_i];
                }
                return children.apply(void 0, __spreadArray([], __read(rest), false));
            }
            // eslint-disable-next-line react/jsx-curly-newline
            ));
        }
        if (isArray(children)) {
            var childrenDom = React.Children.map(children, function (child, i) {
                var key = (isObject(child) && child.key) || i;
                var childProps = !isUndefined(disabled) ? { key: key, disabled: disabled } : { key: key };
                return isObject(child) ? cloneElement(child, childProps) : child;
            });
            return (React.createElement(Control, __assign({}, props, { field: undefined, rules: rules }), childrenDom));
        }
        if (React.Children.count(children) === 1) {
            if (field) {
                var key = ((_a = formListContext === null || formListContext === void 0 ? void 0 : formListContext.getItemKey) === null || _a === void 0 ? void 0 : _a.call(formListContext, field)) || field;
                return (React.createElement(Control, __assign({ disabled: disabled }, props, { key: key, _key: key, rules: rules }), children));
            }
            if (isObject(children)) {
                // Compatible Form.Control
                if ((_b = children.type) === null || _b === void 0 ? void 0 : _b.isFormControl) {
                    return children;
                }
                var childProps = isUndefined(disabled) ? {} : { disabled: disabled };
                return (React.createElement(Control, __assign({}, props, { field: undefined, rules: rules }), cloneElement(children, childProps)));
            }
        }
        return children;
    };
    var FormItemContext = RawFormItemContext;
    var newFormContext = __assign({}, formContext);
    if (!props.noStyle) {
        newFormContext.wrapperCol = undefined;
        newFormContext.labelCol = undefined;
    }
    var getFormItemStyle = function (style) {
        if (['mini', 'small', 'default'].includes(itemSpacingSizeVal)) {
            return style;
        }
        return __assign({ marginBottom: itemSpacingSizeVal }, style);
    };
    var formItemDom = (React.createElement(ConfigProvider, { errorsContent: isTooltipDisplayType ? errorInfo : undefined, tooltipErrorProps: isTooltipDisplayType && ((_h = errorInfo[0]) === null || _h === void 0 ? void 0 : _h.message)
            ? { content: errorInfo[0].message, mode: 'error' }
            : undefined },
        React.createElement(FormContext.Provider, { value: newFormContext },
            React.createElement(FormItemContext.Provider, { value: contextProps }, props.noStyle ? (cloneElementWithDisabled()) : (React.createElement(Row, __assign({ "data-tid": "m4b_form_item", ref: ref }, omit(rest, [
                'children',
                'prefixCls',
                'store',
                'initialValue',
                'field',
                'labelCol',
                'wrapperCol',
                'colon',
                'disabled',
                'rules',
                'trigger',
                'triggerPropName',
                'validateTrigger',
                'noStyle',
                'hasFeedback',
                'help',
                'normalize',
                'formatter',
                'getValueFromEvent',
                'shouldUpdate',
                'field',
                'isInner',
                'labelAlign',
                'layout',
                'isFormList',
                'subTitle',
                'helpTip',
                'helpTipTooltipProps',
                'prompt',
                'optional',
                'description',
                'showLabel',
                'customColspan',
                'requiredSymbol',
                'validateMessagesDisplayType',
            ]), { className: classNames, div: formLayout !== 'horizontal', style: getFormItemStyle(style) }),
                label || props.showLabel ? (React.createElement(Col, __assign({}, (props.labelCol || formContext.labelCol), { className: cs(labelClassNames, (_j = props.labelCol) === null || _j === void 0 ? void 0 : _j.className, (_k = formContext.labelCol) === null || _k === void 0 ? void 0 : _k.className, (_c = {},
                        _c["".concat(prefixCls, "-label-item-flex")] = !props.labelCol && !formContext.labelCol,
                        _c)) }),
                    React.createElement(FormItemLabel, { htmlFor: props.field && formContext.getFormElementId(props.field), subTitle: subTitle, helpTip: helpTip, helpTipTooltipProps: helpTipTooltipProps, optional: optionalVal, requiredSymbol: 'requiredSymbol' in props ? props.requiredSymbol : formContext.requiredSymbol, label: label, prefix: prefix, layout: formLayout, showColon: 'colon' in props ? props.colon : formContext.colon }))) : null,
                React.createElement(Col, __assign({ className: cs("".concat(prefixCls, "-item-wrapper"), (_d = {},
                        _d["".concat(prefixCls, "-item-wrapper-flex")] = !props.wrapperCol && !formContext.wrapperCol,
                        _d)) }, (props.wrapperCol || formContext.wrapperCol)),
                    description && (React.createElement("div", { className: "".concat(prefixCls, "-description") },
                        description.title && (React.createElement("span", { className: "".concat(prefixCls, "-description-title") }, description.title)),
                        isString(description.content) ? (React.createElement("span", { className: "".concat(prefixCls, "-description-content") }, description.content)) : (description.content))),
                    !promptIsBottom && prompt && (React.createElement("div", { className: "".concat(prefixCls, "-prompt"), style: {
                            marginBottom: '8px',
                        } }, isString(promptContent) ? React.createElement("span", null, promptContent) : promptContent)),
                    cloneElementWithDisabled(),
                    React.createElement(FormItemTip, { validateMessagesDisplayType: validateMessagesDisplayType, prefixCls: prefixCls, help: props.help, errors: errorInfo, warnings: warningInfo }),
                    extra && React.createElement("div", { className: "".concat(prefixCls, "-extra") }, extra),
                    promptIsBottom && prompt && (React.createElement("div", { className: "".concat(prefixCls, "-prompt"), style: {
                            // paddingLeft: isString(prompt) ? '12px' : 0,
                            marginTop: '8px',
                        } }, isString(promptContent) ? React.createElement("span", null, promptContent) : promptContent)))))))));
    if (isVertical && !closeColumns && !formItemAlone) {
        /**
         * 如果form-item 没有设定自己的 customColspan， 则根据全局的分列计算，否则使用设定的 span。
         */
        return React.createElement(Col, { span: (_l = props.customColspan) !== null && _l !== void 0 ? _l : 24 / columnsNum }, formItemDom);
    }
    return formItemDom;
};
var ItemComponent = forwardRef(Item);
ItemComponent.defaultProps = {
    trigger: 'onChange',
    triggerPropName: 'value',
};
ItemComponent.displayName = 'FormItem';
export default ItemComponent;
